import { useQuery } from '@tanstack/react-query';
import { getSharedProfileStatus } from '../api/shared-profile.api';

/**
 * Check a share link's status (MYN-58) - a definitive backend answer, so no
 * retry (mirrors `useAuth`'s treatment of a similarly definitive check).
 */
export function useSharedProfileStatus(token: string) {
  return useQuery({
    queryKey: ['shared-profile', token, 'status'],
    queryFn: () => getSharedProfileStatus(token),
    retry: false,
  });
}
